export const dataAsPerOurIotDevices = [
  {
    icon: <i className="fi fi-sr-user-gear flex items-center"></i>,
    label: "As per property management",
    key: 0,
    value: 0,
  },
  {
    icon: <i className="fi fi-rs-camera-cctv flex items-center"></i>,
    label: "As per property management",
    key: 1,
    value: 0,
  },
  {
    icon: <i className="fi fi-ts-cars flex items-center"></i>,
    label: "Google traffic and RTO data",
    key: 2,
    value: 0,
  },
  {
    icon: <i className="fi fi-ss-road flex items-center"></i>,
    label: "Roadster Data",
    key: 3,
    value: 0,
  },
  {
    icon: <i className="fi fi-bs-smartphone flex items-center"></i>,
    label: "Mobile  Device SDK Data",
    key: 4,
    value: 0,
  },
];

export const audienceTypeDataTab = [
  {
    icon: <i className=""></i>,
    label: "Working Prof-A",
    key: 0,
  },
  {
    icon: <i className=""></i>,
    label: "Working Prof-B",
    key: 1,
  },
  {
    icon: <i className=""></i>,
    label: "Working Prof-C",
    key: 2,
  },
];
